import { useEffect, useState } from 'react';
import ConsentService from '../services/consent.service';
import { ConsentType, Consent } from '../types/consent';

export function useConsent(token: string, type: ConsentType) {
  const [consent, setConsent] = useState<Consent | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchConsent() {
      setLoading(true);
      setError(null);
      try {
        const consentData = await ConsentService.getConsentByType(type);
        setConsent(consentData);
      } catch (err: any) {
        setError(err?.response?.data?.message || 'Failed to fetch consent');
      } finally {
        setLoading(false);
      }
    }
    if (token && type) fetchConsent();
  }, [token, type]);

  // Accept/Decline handlers can be implemented as needed
  const acceptConsent = async (token: string) => {
    // Implement API call to accept consent
  };
  const declineConsent = async (token: string) => {
    // Implement API call to decline consent
  };

  return { consent, loading, error, acceptConsent, declineConsent };
}
